import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import CapitalBalanceSummaryRow from './CapitalBalanceSummaryRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ summary }) =>
  (summary || []).map((item, index) => (
    <CapitalBalanceSummaryRow key={item.month || index} {...item} />
  ));

Tbody.propTypes = {
  summary: PropTypes.array.isRequired
};

const CapitalBalanceSummaryTable = ({
  summary,
  count = 0,
  page,
  handleChangePage,
  loading = false,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow sx={{ '& .MuiTableCell-head': { whiteSpace: 'nowrap' } }}>
        <TableCell variant="head" align="center">
          {t('COMMON.DATE')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('CAPITAL_BALANCE.INITIAL_BALANCE')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('COMMON.INVESTMENT')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('CAPITAL_BALANCE.INITIAL_PAYMENT')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('CAPITAL_BALANCE.MONTHLY_PRINCIPAL')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('CAPITAL_BALANCE.CAPITAL_CONTRIBUTION')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('CAPITAL_BALANCE.RESIDUAL_PAYMENT')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('CAPITAL_BALANCE.FINAL_BALANCE')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(() => () => <Tbody summary={summary} />, [summary]);

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
      />
    ),
    [page, count, handleChangePage]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

CapitalBalanceSummaryTable.propTypes = {
  summary: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};

export default CapitalBalanceSummaryTable;

